/**
 * Shared product search result cache (60s TTL).
 * Used by Product page to avoid redundant fetches when navigating.
 * Cleared on product mutations via API interceptor.
 */

const PRODUCT_CACHE_TTL_MS = 60000;
const productSearchCache = new Map();
const productSearchCacheExpiry = new Map();

export const getCacheKey = (page, search, category) => `${search}|${category}|${page}`;

export const getCached = (cacheKey) => {
  const cached = productSearchCache.get(cacheKey);
  const expiry = productSearchCacheExpiry.get(cacheKey);
  if (cached && expiry && Date.now() < expiry) return cached;
  return null;
};

export const setCached = (cacheKey, data) => {
  productSearchCache.set(cacheKey, data);
  productSearchCacheExpiry.set(cacheKey, Date.now() + PRODUCT_CACHE_TTL_MS);
};

export const clearProductSearchCache = () => {
  productSearchCache.clear();
  productSearchCacheExpiry.clear();
};
